import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-product-waste',
  templateUrl: './product-waste.component.html',
  styleUrls: ['./product-waste.component.css']
})
export class ProductWasteComponent implements OnInit {
    public setting?: Setting;

    public selectListProductType: ProductTypeItem[] = [];

    public grid?: GridOptions;

    public searchTextButtons: FormButton[] = [
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.loadGrid() }
    ];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(3479))[0];
    }

    private async loadProductTypes() {
        this.selectListProductType = await this.datatask.Post(219);
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_productWasteGrid')
                .setLoadDataFunction({
                    method: 3419,
                    parameters: this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public searchItems() {
        this.loadGrid();
    }

    public onChanged(_: string | number, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'searchtext':
                if (this.setting.searchtext === '') this.loadGrid();
                break;
            case 'prodtype_no':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadProductTypes();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prodtype_no: number;
    searchtext: string;
}

interface ProductTypeItem {
    prodtype_no: number;
    prodtype_name: string;
    orderby: number;
}
